import React from 'react';
import { motion } from 'framer-motion';
interface CardProps {
  children: ReactNode;
  className?: string;
  delay?: number;
}
export function Card({
  children,
  className = '',
  delay = 0
}: CardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.5,
    delay
  }} className={`bg-bg-card rounded-xl border border-border shadow-card hover:shadow-card-hover hover:border-brand-gold/20 transition-all duration-300 hover:-translate-y-1 ${className}`} data-id="element-41">
      <div className="relative z-10" data-id="element-42">{children}</div>
    </motion.div>;
}